import SettingsCommsPreferencesModule from './settings-comms-preferences.module'

export default SettingsCommsPreferencesModule
